import React, { useCallback, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IoChevronBack } from 'react-icons/io5';

import { getCongressItemAction } from '../../actions/contentActions';
import Infos from '../../components/CongressView/Infos/Infos';
import styles from './CongressView.module.scss';

export default function CongressView() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const congress = useSelector((state) => state.content.congressItem);

  const load = useCallback(() => {
    if (id) getCongressItemAction(dispatch, id);
  }, [dispatch, id]);

  useEffect(() => {
    load();
  }, [load]);

  function formatDate(date) {
    const d = new Date(date);
    return `${new Intl.DateTimeFormat('fr', {
      year: 'numeric', month: 'numeric', day: 'numeric',
    }).format(d)} à ${new Intl.DateTimeFormat('fr', {
      hour: 'numeric', minute: 'numeric', hour12: false,
    }).format(d)}`;
  }

  return (
    <div className={styles.container}>
      <header>
        <div className={styles.title}>
          <h2>{congress?.name || 'Congrès'}</h2>
          <Link to="/majee/congres" className={styles.back}>
            <IoChevronBack size={18} />
            Retour à la liste
          </Link>
        </div>
        {congress?.updatedAt && (
          <p className={styles.updated}>
            Dernière modification :
            {' '}
            <span>{formatDate(congress.updatedAt)}</span>
          </p>
        )}
      </header>

      <main className={styles.content}>
        {congress?._id && <Infos congress={congress} />}
      </main>
    </div>
  );
}
